import { useState } from 'react';
import { fetchActiveRevision } from 'src/api/queries';
import { useQuery } from '@tanstack/react-query';
import { useRevisionStepsConfigs } from 'src/hooks/useRevisionStepsConfigs';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { useNavigate } from 'react-router-dom';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';
import {
  FormFieldManuscript,
  FormFieldTitlePage
} from '@publishing-engine/domain/types/article';

const scrollToTop = () => window.scrollTo({ top: 0 });

const RevisionSteps: React.FC = () => {
  const { steps } = useRevisionStepsConfigs();
  const {
    workflowResponse: { submissionId, workflowData: { currentState } }
  } = useSubmissionData();
  const { getFieldState, checkFormFieldValueIsUpdated } =
    useSubmissionFields('submission');
  const configs = {
    TitlePage: getFieldState('TitlePage')
      ?.formFieldDefinition as FormFieldTitlePage,
    Manuscript: getFieldState('Manuscript')
      ?.formFieldDefinition as FormFieldManuscript
  };
  const titlePageUpadte = configs.TitlePage
    ? checkFormFieldValueIsUpdated(configs.TitlePage.name)
    : false;
  const ManuscriptUpadte = configs.Manuscript
    ? checkFormFieldValueIsUpdated(configs.Manuscript.name)
    : false;
  const initialStep =
    currentState === 'unsubmitted'
      ? 0
      : titlePageUpadte && ManuscriptUpadte
        ? 4
        : 0;
  const totalStepsForAuthor = steps.length;

  const [currentStep, setCurrentStep] = useState<number>(initialStep);

  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ['active-revision', { submissionId, roleType: 'author' }],
    queryFn: () => fetchActiveRevision(submissionId, 'author'),
    retry: 0
  });

  const goToNextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(prev => prev + 1);
      scrollToTop();
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
      scrollToTop();
    }
  };

  const step =
    steps[currentStep > steps.length ? steps.length - 1 : currentStep];
  return (
    step && (
      <>
        <step.Component
          currentStep={currentStep}
          totalSteps={totalStepsForAuthor}
          goToNextStep={goToNextStep}
          goToPreviousStep={goToPreviousStep}
          goToStep={setCurrentStep}
          onClose={() => navigate('?submissionType=my-submissions-active')}
          revisionRound={data}
        />
      </>
    )
  );
};

export default RevisionSteps;
